<template>
<v-container>
  <doc-getting-started></doc-getting-started>
  <doc-use-socketio></doc-use-socketio>
  <doc-control-switch></doc-control-switch>
</v-container>
</template>

<script>
import GettingStarted from './docs/getting_started'
import UseSocketIO from './docs/use_socketio'
import ControlSwitch from './docs/control_switch'

export default {
  name: 'Documents',
  components: {
    'doc-getting-started': GettingStarted,
    'doc-use-socketio': UseSocketIO,
    'doc-control-switch': ControlSwitch
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents.vue